import { CyclesTabs } from './modules/Tabs';
import { ContractScreensHeader } from './modules/Header';
import ColumnVisibilityMenu from '../../components/ScreenCyclesTable/ColumnVisibilityMenu';

export const ContractScreensViewOptimized = () => {
  return (
    <div className="p-contract-screens-view-optimized flex gap-y-2 h-full w-full flex-col pb-4 md:pb-25">
      <ContractScreensHeader />
      <div className="flex justify-end">
        <ColumnVisibilityMenu />
      </div>
      <CyclesTabs />
    </div>
  );
};
